import type { ICurrentAdmissionApplication } from '@/api/endpoints/schools/schoolSelectionPanel';
import type { IPaginationSettings } from '@/api/types';
import type { ETestStatus } from '@/shared/types';

export interface ITest {
  id: number;
  status: ETestStatus;
  block_user: boolean;
  user: {
    full_name: string;
    email: string;
    phone: string;
  };
  rejection_reason: string | null;
  approval_comment: string | null;
  result_notified_at: string | null;
  decision_notified_at: string | null;
}

export interface ITestingParticipantsStats {
  total: number;
  not_started: number;
  in_progress: number;
  on_review: number;
  test_passed: number;
  test_failed: number;
  in_reserve: number;
  approved: number;
  rejected: number;
}

export interface ITestingParticipantsResponse {
  data: ITest[];
  meta: {
    pagination: IPaginationSettings;
    stats: ITestingParticipantsStats;
  };
}

/**
 * Статусы этапа тестирования
 */
export enum EAdmissionTestingStatus {
  Draft = 'draft',
  InProgress = 'in_progress',
  ReadyForResults = 'ready_for_results',
  ResultsNotified = 'results_notified',
  ReadyForDecisions = 'ready_for_decisions',
  Finished = 'finished',
}

export interface IAdmissionTesting {
  id: number;
  school_id: number;
  lms_course_id: number;
  status: EAdmissionTestingStatus;
  results_notified_at: string;
}

export interface IAdmissionTestingResponse {
  data: IAdmissionTesting;
}

export interface ISendTestResultsResponse {
  data: {
    count: number;
    admission_testing: IAdmissionTesting;
  };
}

export interface ITestingParticipant extends Omit<ITest, 'decision_notified_at'> {
  admission_application: Omit<ICurrentAdmissionApplication, 'user'>;
}

export interface ITestingParticipantResponse {
  data: ITestingParticipant;
}
